import React from 'react';
import MenuHome from '../../../components/MenuHome';
import MenuComputerScience from '../../../components/MenuComputerScience';
import MenuProgramming from '../../../components/MenuProgramming';
import '../../../styles/main.scss';

const Perl = () => {
  return <div>
        <div className="title">Perl</div>
        <div class="caption">Practical Extraction Report Language</div>
        <MenuHome />
        <MenuComputerScience />
        <MenuProgramming />
  </div>;
};

export default Perl;